import QuestionsList from "./QuestionsList";

const Information = () => <QuestionsList />;

export default Information;
